import { LUIGI_DELETED_STATUS } from '@utils/constants';
export function triggerDeletedFieldsError(annotations) {
  const error = {
    fields: [] as string[],
    filters: [] as string[],
  };
  annotations?.forEach((item) => {
    if (item?.code === LUIGI_DELETED_STATUS) {
      const newError = item.error;
      error.fields = [...new Set([...error.fields, ...newError.fields])];
      error.filters = [...new Set([...error.filters, ...newError.filters])];
    }
  });
  if (error.fields.length || error.filters.length) {
    const data = {
      code: LUIGI_DELETED_STATUS,
      error,
    };
    const event = new CustomEvent('LUIGI_DELTED_STATUS', { detail: { data } });
    document.dispatchEvent(event);
  }
}
